<template>
  <div>
    <fieldset :disabled="loading">
      <div class="mb-3">
        <mobile-sign
          ref="mobileSign"
          :items="mobileItems"
          @onloading="imzalayiciOnLoading"
          @completed="completed"
        ></mobile-sign>
        <div class="text-info">{{ processingMessage }}</div>
      </div>
      <div class="commands">
        <div class="row">
          <div class="btn-group" role="group">
            <button
              type="button"
              class="btn btn-secondary"
              @click="$emit('cancel')"
            >
              Vazgeç
            </button>
            <button type="button" class="btn btn-success" style="touch-action: manipulation;" :disabled="!signButtonEnabled || loading || isSigning" @click="sign">
              İmzala
            </button>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
import MobileSign from "./MobileSign.vue";
import axios from "axios";

export default {
  components: {
    MobileSign
  },
  data() {
    return {
      description: "",
      loading: false,
      processingMessage: null,
      signButtonEnabled: true,
      isSigning: false   // <-- yeni
    };
  },
  props: {
    isRem : {
      type: Boolean,
      default: false,
    },
    remSigningItems:{
      type: Array,
      required: false
    },
    remFinalizer:{
      type: Object,
      required: false
    },
    data: {
      type: Object,
      required: true
    }
  },
  mounted() {
    // this.$refs.description.focus();
  },
  created(){
    if(!this.isRem)
      this.checkSigner()
  },
  methods: {
    async checkSigner(){
      await axios.get(`/Job/CheckSigner/${this.data.Id}`).then(() => {  
        this.signButtonEnabled = true;  
      }).catch(() => {
          this.signButtonEnabled = false;  
          this.$izonayAlert(this.data.TrackingNo.Serial + ' - ' + this.data.TrackingNo.Number + ' numaralı işin içerisindeki dokümanları daha önce imzaladığınız için yeniden imza atamazsınız.');
      }) 
    },
    remSigningCompleted(){
        // Dosyaların imzalanması tamamlandığında sunucu tarafında kabul işlemini başlatır.
        this.loading = true;

        this.processingMessage = 'KEP Gönderiliyor...' ;
        this.$forceUpdate();

        axios.get(`/rem/sendrem/?jobId=${this.data.Id}&finalizerId=${this.remFinalizer.Id}`).then(x => {
            if(x.data.Success) {
                this.$router.push({ name: "Job", hash: "#Rem" });
                this.$izonayAlert(`İmzalama işlemi başarıyla tamamlandı.<br/><code>${ this.$options.filters.trackingNo(this.data.TrackingNo) }</code>`, "success");
            } else {
                this.$izonayAlert(x.data.ErrorMessages);
                this.loading = false;
            }
        }).catch(x => {
            console.warn('KEP gönderim işlemi başarısız: ', x);
            this.$izonayAlert("KEP gönderim işlemi başarısız.");
        }).then(() => {
          this.loading = false;
          this.processingMessage = null;
        }); 
    },
    sign() {
      // Senkron kilit — Vue reaktivitesini beklemez
      if (this._signLock) return;
      this._signLock = true;

      // Reaktif kilit — buton görsel olarak disable olsun
      this.isSigning = true;
      this.$refs.mobileSign.sign();
    },
    completed() {
      if (this._completedLock) return;
      this._completedLock = true;
      this.loading = true;
      this.processingMessage = "İmzalanan dosyalar işleniyor. Lütfen bekleyiniz...";
      this.$forceUpdate();

      var descriptionQuery = this.description ? `?description=${this.description}` : "";
      if(this.isRem){
        this.remSigningCompleted()
      }else {
        axios.get(`/job/acceptSignedFiles/${this.data.Id}${descriptionQuery}`)
        .then(x => {
          if (x.data.Success) {
            this.$router.push({ name: "Job", hash: "#MyWaiting" });
            this.$izonayAlert(`İmzalama işlemi başarıyla tamamlandı.<br/><code>${ this.$options.filters.trackingNo(this.data.TrackingNo) }</code>`, "success");
          } else {
            this.$izonayAlert(x.data.ErrorMessages);
            this.$refs.imzalayici.loading = false;
            this.loading = false;
          }
        })
        .catch(x => {
           if (this.isDuplicateBlocked(x)) return;  
          console.warn("Dosya kabul işlemi başarısız: ", x);
          this.$izonayAlert("İmzalanan dosya işleme alınamadı.");
          this._signLock = false;
          this._completedLock = false;
          this.isSigning = false;
        })
        .then(() => {
          this.loading = false;
          this.processingMessage = null;
        });
      }
      this.$emit("completed");
    },
    imzalayiciOnLoading(loading){
      this.loading = loading;
    }
  },
  computed: {
    mobileItems() {
      if(this.isRem){
        return this.remSigningItems;
      } else{
        return this.data.Documents.map(x => ({
          DocumentId: x.Id,
          SignatureFormat: x.SignatureFormat,
          FileName: x.UnsignedFile.FileName,
          Size: x.UnsignedFile.Size,
          State: "",
          FingerprintUrl: `/MobileSign/CalculateFingerprint/${this.data.Id}?documentId=${x.Id}`,
          PostUrl: `/MobileSign/Sign/${this.data.Id}?documentId=${x.Id}&fingerPrintTempFileId={0}`,
          PostParams: { JobId: this.data.Id, DocumentId: x.Id }
        }));
      }
      
    }
  }
};
</script>
